import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach admin token from localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ============ Public GET endpoints ============
export const getAuthor = () => api.get('/author').then(r => r.data);
export const getBooks = () => api.get('/books').then(r => r.data);
export const getReviews = () => api.get('/reviews').then(r => r.data);
export const getGallery = () => api.get('/gallery').then(r => r.data);
export const getVideos = () => api.get('/videos').then(r => r.data);
export const getBlog = () => api.get('/blog').then(r => r.data);
export const getMedia = () => api.get('/media').then(r => r.data);
export const getStats = () => api.get('/stats').then(r => r.data);

export const submitContact = (data) => api.post('/contact', data).then(r => r.data);
export const subscribeNewsletter = (email) => api.post('/newsletter', { email }).then(r => r.data);

// ============ Auth ============
export const login = (email, password) => api.post('/auth/login', { email, password }).then(r => r.data);
export const logout = () => api.post('/auth/logout').then(r => r.data);
export const getMe = () => api.get('/auth/me').then(r => r.data);

// ============ Admin CRUD ============
export const updateAuthor = (data) => api.put('/author', data).then(r => r.data);
export const updateStats = (data) => api.put('/stats', data).then(r => r.data);

export const createBook = (data) => api.post('/books', data).then(r => r.data);
export const updateBook = (id, data) => api.put(`/books/${id}`, data).then(r => r.data);
export const deleteBook = (id) => api.delete(`/books/${id}`).then(r => r.data);

export const createReview = (data) => api.post('/reviews', data).then(r => r.data);
export const updateReview = (id, data) => api.put(`/reviews/${id}`, data).then(r => r.data);
export const deleteReview = (id) => api.delete(`/reviews/${id}`).then(r => r.data);

export const createGallery = (data) => api.post('/gallery', data).then(r => r.data);
export const updateGallery = (id, data) => api.put(`/gallery/${id}`, data).then(r => r.data);
export const deleteGallery = (id) => api.delete(`/gallery/${id}`).then(r => r.data);

export const bulkUploadGallery = (files, category, onUploadProgress) => {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append('files', f));
  fd.append('category', category);
  return api.post('/gallery/bulk', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  }).then(r => r.data);
};

export const createVideo = (data) => api.post('/videos', data).then(r => r.data);
export const updateVideo = (id, data) => api.put(`/videos/${id}`, data).then(r => r.data);
export const deleteVideo = (id) => api.delete(`/videos/${id}`).then(r => r.data);

export const createBlog = (data) => api.post('/blog', data).then(r => r.data);
export const updateBlog = (id, data) => api.put(`/blog/${id}`, data).then(r => r.data);
export const deleteBlog = (id) => api.delete(`/blog/${id}`).then(r => r.data);

export const createMedia = (data) => api.post('/media', data).then(r => r.data);
export const updateMedia = (id, data) => api.put(`/media/${id}`, data).then(r => r.data);
export const deleteMedia = (id) => api.delete(`/media/${id}`).then(r => r.data);

export const getContacts = () => api.get('/contact').then(r => r.data);
export const deleteContact = (id) => api.delete(`/contact/${id}`).then(r => r.data);
export const getNewsletterSubs = () => api.get('/newsletter').then(r => r.data);

export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

export default api;
